import SearchIcon from '@mui/icons-material/Search'
import { Grid } from '@mui/material'
import Button from '@mui/material/Button'
import dayjs, { Dayjs } from 'dayjs'
import { useCallback, useState } from 'react'

import ClearIcon from '@mui/icons-material/Clear'
import DateRangePicker from '../../../../../components/DateRangePicker'
import CategorySelectSearch from '../../../../../components/SelectSearch/CategorySelectSearch'
import ChannelSelectSearch from '../../../../../components/SelectSearch/ChannelSelectSearch'
import ProductGroupSelectSearch from '../../../../../components/SelectSearch/ProductGroupSelectSearch'
import ProductSelectSearch from '../../../../../components/SelectSearch/ProductSelectSearch'

export interface IByDistributionFilterMapped {
  categoryObjectIds?: string[]
  distributionObjectIds?: string[]
  productObjectIds?: string[]
  productGroups?: string[]
  startDate?: string
  endDate?: string
  page?: number
  perPage?: number
}

interface FilterGroupProps {
  filter: IByDistributionFilterMapped
  onFilterChange: (filter: IByDistributionFilterMapped) => void
  onSearch: (filter: IByDistributionFilterMapped) => void
}

const DailySalesByDistributionReportFilter = (props: FilterGroupProps) => {
  const { filter, onFilterChange, onSearch } = props
  const {
    startDate,
    endDate,
    productObjectIds,
    distributionObjectIds,
    categoryObjectIds,
  } = filter
  const [resetAutoComplete, setResetAutoComplete] = useState<string>('')

  const handleFilterChange = useCallback(
    (newFilter: Partial<IByDistributionFilterMapped>) => {
      onFilterChange({ ...filter, ...newFilter })
    },
    [filter, onFilterChange],
  )

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={4}>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onChange={(startDate, endDate) => {
            onFilterChange({ ...filter, startDate, endDate })
          }}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <ProductSelectSearch
          resetAutoComplete={resetAutoComplete}
          products={productObjectIds}
          handleFilterChange={handleFilterChange}
          onSelect={(e) => {
            const selectedProductIds = e?.map(
              (product: any) => product?.value?.objectId,
            )
            handleFilterChange({ productObjectIds: selectedProductIds })
          }}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <ProductGroupSelectSearch
          resetAutoComplete={resetAutoComplete}
          productGroups={filter.productGroups}
          onSelect={(e) => {
            const selectedGroupIds = e?.map((group) => group.value.objectId)
            handleFilterChange({ productGroups: selectedGroupIds })
          }}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <CategorySelectSearch
          resetAutoComplete={resetAutoComplete}
          categories={categoryObjectIds ?? []}
          onSelect={(e) => {
            const selectedCategoryIds = e?.map(
              (category: any) => category?.value?.objectId,
            )
            onFilterChange({
              ...filter,
              categoryObjectIds: selectedCategoryIds,
            })
          }}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <ChannelSelectSearch
          resetAutoComplete={resetAutoComplete}
          selected={distributionObjectIds ?? []}
          label={'เลือกช่องทางการขาย'}
          onSelect={(e) => {
            const selectedChannelIds = e?.map(
              (channel: any) => channel?.value?.objectId,
            )
            onFilterChange({
              ...filter,
              distributionObjectIds: selectedChannelIds,
            })
          }}
        />
      </Grid>
      <Grid item xs={12} lg={2}>
        <Button
          color="primary"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={4} lg={2}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => {
            const defaultFilter: IByDistributionFilterMapped = {
              categoryObjectIds: undefined,
              distributionObjectIds: undefined,
              productObjectIds: undefined,
              productGroups: undefined,
              startDate: dayjs().subtract(30, 'days').format(),
              endDate: dayjs().format(),
              page: 1,
              perPage: 15,
            }
            onFilterChange(defaultFilter)
            onSearch(defaultFilter)
            setResetAutoComplete(new Date().getTime().toString())
          }}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
    </Grid>
  )
}

export default DailySalesByDistributionReportFilter
